import Icon from "@components/ui/icon";
import Popover from "@components/ui/popover";
import { cn } from "@lib/cn";
import { useMemo, useState } from "react";
import { AI_IMAGE_MODELS } from "../constants";
import { useAiImageStoreShallow } from "../store";

export const AiImageModelSelect = () => {
  const [open, setOpen] = useState(false);
  const { model, setModel } = useAiImageStoreShallow((s) => ({
    model: s.model,
    setModel: s.setModel,
  }));

  const selected = useMemo(() => {
    return AI_IMAGE_MODELS.find((m) => m.value === model);
  }, [model]);

  return (
    <Popover open={open} onOpenChange={setOpen} placement="bottom-start">
      <Popover.Trigger asChild>
        <button
          aria-label="Model"
          type="button"
          className={cn(
            "tw-h-8 tw-flex tw-items-center tw-gap-1.5 tw-pl-[7px] tw-pr-2 tw-font-sans tw-text-xs tw-font-normal tw-text-blue-700 tw-rounded-[100px] hover:tw-bg-blue-50 tw-transition-colors tw-duration-200",
            {
              "tw-bg-blue-50": open,
            },
          )}
        >
          <Icon icon="ri-ai-generate-2" />
          {selected?.name}
        </button>
      </Popover.Trigger>
      <Popover.Content className="tw-w-44 tw-p-1 tw-rounded-xl tw-z-[99999] tw-bg-white tw-space-y-0.5 tw-shadow-popover tw-border tw-border-solid tw-border-blue/5">
        {AI_IMAGE_MODELS.map((m) => (
          <button
            aria-label={m.label}
            type="button"
            key={m.value}
            onClick={() => {
              setModel(m.value as "basic" | "pro");
              setOpen(false);
            }}
            className={cn(
              "tw-w-full tw-text-left tw-flex-col tw-px-3 tw-py-2 tw-flex tw-rounded-lg tw-text-xs tw-font-normal tw-text-blue tw-transition-colors hover:tw-bg-blue-50",
              {
                "tw-bg-primary-50": m.value === selected?.value,
              },
            )}
          >
            {m.label}
            <span className="tw-mt-1 tw-block tw-text-xs tw-text-blue-500">
              {m.description}
            </span>
          </button>
        ))}
      </Popover.Content>
    </Popover>
  );
};
